import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import TimelineSection from './components/TimelineSection';
import HonorsSection from './components/HonorsSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <CategoryNav />
        <FeaturedArticles />
        <TimelineSection />
        <HonorsSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}